// extracted by css-extract-rspack-plugin
export default {"ellipsis":"akClyb_1r8AsH6OU__ellipsis___"};